export const getGeography = item => {
  return item?.area?.name || item?.dataset?.metadata?.ecoinvent_geography || '';
};
